import { render, staticRenderFns } from "./EditorNewNoedit.vue?vue&type=template&id=933576a4&"
import script from "./EditorNewNoedit.vue?vue&type=script&lang=js&"
export * from "./EditorNewNoedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports